import React, { useEffect, useState } from 'react'
import { InputCP } from 'main/common/components/form-fields/input/InputCP'
import { MailIconCP } from 'main/common/components/icons/MailIconCP'
import { useFormStateManager } from 'main/common/form-state-manager/UseFormStateManager'
import { NotificationHelper } from 'main/common/helpers/NotificationHelper'
import { useRequest } from 'main/common/request-manager/use-request/UseRequest'
import { AuthRequests } from 'main/modules/auth/services/AuthRequests'
import { AuthFormFooterCP } from 'main/modules/auth/components/auth-form-footer/AuthFormFooterCP'
import { RecoverPwdFormValidator } from 'main/modules/auth/components/recover-password-form/inner/RecoverPwdFormValidator'
import { RequestUtils } from 'main/common/request-manager/RequestUtils'
import { SchemaIconCP } from 'main/common/components/icons/SchemaIconCP'
import { AppStateUtils } from 'main/common/utils/AppStateUtils'
import { HttpStatusEnum } from 'main/common/enums/HttpStatusEnum'
import { OrUndefTP } from 'main/common/types/OrUndefTP'

interface IRecoverPasswordFormCPProps {
    goToLogin: () => void
}

/**
 * COMPONENTE
 * Formulario de RECUPERAR SENHA.
 *
 * @author Stella
 * @author hjcostabr
 */
export function RecoverPasswordFormCP(props: IRecoverPasswordFormCPProps): JSX.Element {

    const [formValidator] = useState<RecoverPwdFormValidator>(new RecoverPwdFormValidator({ schema: AppStateUtils.getDomainSlug() }))
    const formStateManager = useFormStateManager(formValidator)

    const request = useRequest<void>(undefined, 'none')
    useEffect(onRequestChange, [request.isAwaiting])

    function onRequestChange(): void {

        if (request.isAwaiting || !request.wasTried)
            return

        if (!request.isSuccess)
            return handleRequestFailure()

        NotificationHelper.success('Sucesso', 'Senha redefinida com sucesso! Verifique seu e-mail e prossiga com o login')
        props.goToLogin()
    }

    function handleRequestFailure(): void {

        let errorNotification: string
        let errorLog: OrUndefTP<string>

        if (request.responseStatus === HttpStatusEnum.FORBIDDEN)
            errorNotification = 'Domínio inativo ou não reconhecido'

        else if (request.responseStatus === HttpStatusEnum.NOT_FOUND)
            errorNotification = 'e-mail não reconhecido'

        else {
            errorNotification = 'Falha ao tentar realizar login'
            errorLog = 'Falha inesperada'
        }

        if (!!errorLog)
            console.error('FALHA - RecoverPasswordFormCP.onRequestChange: ', errorLog, request.responseData, request.error)

        RequestUtils.showDefaultErrorNotification(request.error, errorNotification)
    }

    async function onFormSubmit(): Promise<void> {

        formStateManager.setConsiderAllErrors(true)
        if (!await formStateManager.validate())
            return

        const formValues = formStateManager.getFormValues()
        if (!formValues)
            return

        request.runRequest(AuthRequests.recoverPassword(formValues.schema, { email: formValues.email }))
    }

    return (
        <>
            <InputCP
                label={'Dominio'}
                fieldName={'schema'}
                formStateManager={formStateManager}
                required={true}
                onFormSubmit={onFormSubmit}
                icon={<SchemaIconCP/>}
            />

            <InputCP
                label={'E-mail'}
                fieldName={'email'}
                formStateManager={formStateManager}
                required={true}
                onFormSubmit={onFormSubmit}
                icon={<MailIconCP/>}
            />

            <AuthFormFooterCP
                link={{
                    text: 'Voltar para login',
                    onClick: props.goToLogin,
                }}
                button={{
                    text: 'Recuperar Senha',
                    onClick: onFormSubmit,
                }}
                awaiting={request.isAwaiting}
            />
        </>
    )
}
